import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { open, close } from "../redux/popupSlice";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

import Popup01 from "../pages/popup/Popup01"
import PopupPlusMember from "../pages/popup/PopupPlusMember"

export default function PaginationMemberList(props) {
    const {
        coupon,
        teams,
        setSelectedItems,
        modifyLicense,
        chkReset,
        teamId
    } = props

    const dispatch = useDispatch();
    const lang = useSelector(state => state.langReducer.lang);

    const dataList = coupon || [];

    const [checkboxStates, setCheckboxStates] = useState(new Array(dataList.length).fill(false));
    const [isAllChecked, setIsAllChecked] = useState(false);

    const [page, setPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    useEffect(() => {
        setIsAllChecked(false);
        setCheckboxStates(new Array(dataList.length).fill(false))
        setSelectedItems([])
    }, [chkReset]);

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);

    const MeberSetFunc = (email) => {
        dispatch(open({
            component: 
                <PopupPlusMember
                    max_width={'400px'}
                    button={'저장'}
                    buttonCancel={'취소'}
                    member_set={true}
                    member_email={email}
                    teamId={teamId}
                />
        }));
    }

    const CheckboxChange = (event) => {
        const { name, checked } = event.target;

        if(name === "user_all") {
            let listAll = new Array(dataList.length).fill(checked);
            setIsAllChecked(checked)
            setCheckboxStates(listAll);

            const checkedItems = dataList.filter((_, i) => listAll[i]);
            setSelectedItems(checkedItems);

        } else if(name === "user_chk") {
            const index = parseInt(event.target.dataset.index, 10);
            const updatedStates = [...checkboxStates];
            updatedStates[index] = checked;
            setCheckboxStates(updatedStates);

            setIsAllChecked(updatedStates.every((state) => state === true));

        const checkedItems = dataList.filter((_, i) => updatedStates[i]);
           setSelectedItems(checkedItems);
        }
    }

    /* console.log("Current Page:", page);
    console.log("indexOfFirstItem:", indexOfFirstItem, "indexOfLastItem:", indexOfLastItem);
    console.log("Items:", Items); */

    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box plus_member">
                <div className="list_title">
                    {modifyLicense != 0 &&
                        <div className="custom_chk_box inquiry modify">
                            <input 
                                type="checkbox" 
                                className="custom_chk_input"
                                name="user_all"
                                id="user_list"
                                checked={isAllChecked}
                                onChange={CheckboxChange}
                            />
                        </div>
                    }
                    <p className="set">이메일 주소</p>
                    <p className="set">이름</p>
                    <p></p>
                </div>

                {dataList ?
                    <>
                        {Items.map((x, i) => (
                            <div key={x} className={`my_coupon_info plus_member`}>
                                {modifyLicense != 0 &&
                                    <div className="custom_chk_box inquiry modify">
                                        <input 
                                            type="checkbox" 
                                            className="custom_chk_input"
                                            name="user_chk"
                                            id={`user_chk_${indexOfFirstItem + i}`}
                                            data-index={indexOfFirstItem + i}
                                            checked={checkboxStates[indexOfFirstItem + i]}
                                            onChange={CheckboxChange}
                                        />
                                    </div>
                                }
                                <p className="set">{x.invited ? `${x.email} (${lang === 0 ? '초대중' : 'Invited'})` : `${x.email}`}</p>
                                <p className="set">{x.fullname}</p>
                                <p className="member_set">
                                    <span
                                        onClick={() => {
                                            MeberSetFunc(x.email);
                                        }}
                                    >
                                        편집
                                    </span>
                                </p>
                            </div>
                        ))}

                        {/* <div className={`my_coupon_info`}>
                            <p>aiffasf@naver.com</p>
                            <p>이름입니다</p>
                            <p className="license_off">
                                비활성
                            </p>
                            <p className="member_set">
                                <span
                                    onClick={() => {
                                        MeberSetFunc()
                                    }}
                                >
                                    관리
                                </span>
                            </p>
                        </div> */}
                    </>
                    :
                    <p className="not_coupon">결제 내역이 없습니다.</p>
                }                
                
            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={8}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default}/>}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default}/>}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default}/>}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default}/>}
            ></Pagination>
        </div>
    )
}